import { Button, Tag, Typography } from "@hellocarbo/lasagne";
import { ComponentProps, FC, ReactNode, SVGProps } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { cn } from "@/utils/classes";

import UpsellModal from "./UpsellModal";

type ActionButtonProps = ComponentProps<typeof Button>;

export function ActionButton({ children, ...props }: ActionButtonProps) {
  return (
    <UpsellModal>
      <Button
        as={Link}
        shape="outline"
        intent="secondary"
        className="mt-sm"
        {...props}
      >
        {children}
      </Button>
    </UpsellModal>
  );
}

export type BaseCardProps = {
  title: string;
  text: string;
  orientation?: "horizontal" | "vertical";
  Icon: FC<SVGProps<SVGSVGElement>>;
  children?: ReactNode;
  showNewTag?: boolean;
};

function BaseCard({
  orientation = "horizontal",
  Icon,
  title,
  text,
  children,
  showNewTag,
}: BaseCardProps) {
  const { t } = useTranslation(["common"]);

  return (
    <div
      className={cn(
        "p-lg flex rounded-lg bg-white",
        orientation === "horizontal" ? "gap-x-lg" : "gap-y-sm flex-col"
      )}
    >
      <div className="shrink-0">
        <Icon
          role="img"
          className={orientation === "vertical" ? "mx-auto" : ""}
        />
      </div>
      <div>
        <div className="mb-2xs gap-x-2xs flex items-center">
          <Typography as="h3" step="1" weight="bold">
            {title}
          </Typography>
          {showNewTag && <Tag intent="positive" text={t("common:new")} />}
        </div>
        <Typography>{text}</Typography>
        {children}
      </div>
    </div>
  );
}

export default BaseCard;
